export const SpinnerLoaderSecondary = ({ className }: { className?: string }) => (
    <object
        className={` h-[40px] w-[40px] ${className || ''}`}
        type="image/svg+xml"
        data="/icon/SpinnerLoaderSecondary.svg"
    />
);
